import { BaseApiRouteService } from "mrb/core";

class NakiNigunAlbumApiRouteService extends BaseApiRouteService {
    constructor() {
        super("naki-nigun/albums");
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    findSongs(albumId, filter) {
        return super.find(`${this.base}/{id}/songs{?searchQuery,page,rpp,sort,embed,fields}`, {
            id: albumId,
            ...filter,
        });
    }

    deleteAlbumTrack(id) {
        return super.delete(`${this.base}/song/{id}`, { id: id });
    }

    getAllSongs(id, options) {
        return super.get(`${this.base}/{id}/songs/all{?embed,fields}`, id, options);
    }

    updateActiveStatus(id, value) {
        return super.update(`${this.base}/{id}/active{?value}`, { id, value });
    }

    updateScheduledReleaseAt(id) {
        return super.update(`${this.base}/{id}/scheduled-release`, { id });
    }

    updateTrackActiveStatus(id, value) {
        return super.update(`${this.base}/tracks/{id}/active{?value}`, { id, value });
    }

    updateTrackScheduledReleaseAt(id) {
        return super.update(`${this.base}/tracks/{id}/scheduled-release`, { id });
    }

    updatePremiumStatus(id, value) {
        return super.update(`${this.base}/{id}/premium{?value}`, {
            id: id,
            value: value,
        });
    }

    updateFeaturedStatus(id, value) {
        return super.update(`${this.base}/{id}/featured{?value}`, {
            id: id,
            value: value,
        });
    }

    updateOnByDefaultStatus(id, value) {
        return super.update(`${this.base}/{id}/on-by-default{?value}`, {
            id: id,
            value: value,
        });
    }

    updateOnByDefaultInAppStatus(id, value) {
        return super.update(`${this.base}/{id}/on-by-default-in-app{?value}`, {
            id: id,
            value: value,
        });
    }

    updateOnByDefaultInNakiTouchStatus(id, value) {
        return super.update(`${this.base}/{id}/on-by-default-in-embedded-app{?value}`, {
            id: id,
            value: value,
        });
    }

    updateOnByDefaultInHandheldPinkStatus(id, value) {
        return super.update(`${this.base}/{id}/on-by-default-in-kedayo-pink-app{?value}`, {
            id: id,
            value: value,
        });
    }

    updateOnByDefaultInHandheldStatus(id, value) {
        return super.update(`${this.base}/{id}/on-by-default-in-kedayo-app{?value}`, {
            id: id,
            value: value,
        });
    }

    findShufflableNakiNigunAlbum(filter) {
        return super.create(`${this.base}/shufflable-album`, filter);
    }

    updateHlsEnabledStatus(id, value) {
        return super.update(`${this.base}/{id}/hls-enabled{?value}`, {
            id: id,
            value: value,
        });
    }

    editAlbumTrackTitle(id, resources) {
        return super.update(`${this.base}/album-track/{id}/title`, {
            resources: resources,
            id: id,
        });
    }

    uploadAlbumTrack(albumId) {
        return super.create(`${this.base}/{id}/track`, { id: albumId });
    }

    findAudioTrackAlbumSongs(filter) {
        return super.find(
            `${this.base}/songs{?page,searchQuery,albumIds,artistIds,rpp,sort,embed,fields,audioTrackAvailable}`,
            filter
        );
    }

    findAlbums(filter) {
        return super.find(`${this.base}{?page,searchQuery,rpp,sort,embed,fields}`, filter);
    }
}

export default NakiNigunAlbumApiRouteService;
